type Emoji = string;
type AnimalName = string;

const ANIMALS_EMOJI_MAP_ARRAY = [
  ["Dog", "🐶"],
  ["Cat", "🐱"],
  ["Mouse", "🐭"],
  ["Hamster", "🐹"],
  ["Rabbit", "🐰"],
  ["Fox", "🦊"],
  ["Bear", "🐻"],
  ["Panda", "🐼"],
  ["Koala", "🐨"],
  ["Tiger", "🐯"],
  ["Lion", "🦁"],
  ["Cow", "🐮"],
  ["Pig", "🐷"],
  ["Frog", "🐸"],
  ["Monkey", "🐵"],
  ["Chicken", "🐔"],
  ["Penguin", "🐧"],
  ["Bird", "🐦"],
  ["Chick", "🐤"],
  ["Duck", "🦆"],
  ["Eagle", "🦅"],
  ["Owl", "🦉"],
  ["Bat", "🦇"],
  ["Wolf", "🐺"],
  ["Boar", "🐗"],
  ["Horse", "🐴"],
  ["Unicorn", "🦄"],
  ["Bee", "🐝"],
  ["Caterpillar", "🐛"],
  ["Butterfly", "🦋"],
  ["Snail", "🐌"],
  ["Ladybug", "🐞"],
  ["Ant", "🐜"],
  ["Beetle", "🪲"],
  ["Scorpion", "🦂"],
  ["Turtle", "🐢"],
  ["Snake", "🐍"],
  ["Lizard", "🦎"],
  ["Octopus", "🐙"],
  ["Squid", "🦑"],
  ["Crab", "🦀"],
  ["Lobster", "🦞"],
  ["Shrimp", "🦐"],
  ["Fish", "🐠"],
  ["Dolphin", "🐬"],
  ["Whale", "🐳"],
  ["Shark", "🦈"],
  ["Crocodile", "🐊"],
  ["Zebra", "🦓"],
  ["Gorilla", "🦍"],
  ["Orangutan", "🦧"],
  ["Giraffe", "🦒"],
  ["Elephant", "🐘"],
  ["Hippo", "🦛"],
  ["Rhino", "🦏"],
  ["Camel", "🐪"],
  ["Llama", "🦙"],
  ["Goat", "🐐"],
  ["Sheep", "🐑"],
  ["Rooster", "🐓"],
  ["Turkey", "🦃"],
  ["Peacock", "🦚"],
  ["Parrot", "🦜"],
  ["Swan", "🦢"],
  ["Dove", "🕊️"],
  ["Squirrel", "🐿️"],
  ["Hedgehog", "🦔"],
  ["Otter", "🦦"],
  ["Skunk", "🦨"],
  ["Badger", "🦡"],
  ["Bison", "🦬"],
  ["Buffalo", "🐃"],
  ["Bull", "🐂"],
  ["Ram", "🐏"],
  ["Piglet", "🐖"],
  ["Rat", "🐀"],
  ["Beaver", "🦫"],
  ["Seal", "🦭"],
  ["Kangaroo", "🦘"],
  ["Sloth", "🦥"],
  ["Deer", "🦌"],
  ["Raccoon", "🦝"],
] as [AnimalName, Emoji][];

const ANIMALS_EMOJI_MAP = new Map<AnimalName, Emoji>(ANIMALS_EMOJI_MAP_ARRAY);

type AnimalEmoji = { name: AnimalName; emoji: Emoji };

/**
 * Returns a random { name, emoji } pair
 */
export const getRandomAnimalEmoji = (): AnimalEmoji => {
  const randomIndex = Math.floor(
    Math.random() * ANIMALS_EMOJI_MAP_ARRAY.length
  );

  const [name, emoji] = ANIMALS_EMOJI_MAP_ARRAY[randomIndex];

  return { name, emoji };
};

/**
 * Returns emoji for a given animal name (or undefined if not found).
 */
export const getEmojiByAnimalName = (name: AnimalName): Emoji | undefined =>
  ANIMALS_EMOJI_MAP.get(name);
